import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Modal, message, Divider } from 'antd';
import {
  Header,
  Input,
  Button,
  Typography,
  LayoutWithoutAuth,
  InfoBox,
} from 'components';
import { useHistory,useLocation } from 'react-router-dom';
import './signup.less';

import * as loginService from 'services/login.service';
import { customMessages, customValidators } from 'utils';
import { useDispatch } from 'react-redux';

const { Title, Link, Text } = Typography;

const SignupPage = () => {
  let history = useHistory();
  let location = useLocation();
  const data = location.state;
  const  dispatch = useDispatch();
  const [form] = Form.useForm();
  const [valid, setValid] = useState(false);
  
  const onValuesChange = () => {
    setTimeout(() => {
      let inputs = form.getFieldsError();

      for (var i = 0; i < inputs.length; i++) {
        let formItemName = inputs[i]['name'][0];
        if (checkError(formItemName)) {
          setValid(true);
        } else {
          setValid(false);
          break;
        }
      }
    }, 10);
  };

  const checkError = (fieldName) => {
    if (
      form.getFieldError(fieldName).length === 0
    ) {
      return true;
    }
  };

  useEffect(() => {
    onValuesChange();
  }, []);

  return (
    <LayoutWithoutAuth className="signup">
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center" className="signup-box">
            <Col span={24} className="flex-center-center">
              <h1 className="section__title">Üye Ol</h1>
            </Col>
            <Col span={24} className="flex-center-center">
              <p className="info-text--big">
              Yeni üyelik oluşturmak için sisteme kaydolmak istediğiniz Turkcell numaranızı giriniz.
              </p>
            </Col>
            <Form
              form={form}
              style={{ width: '100%' }}
              name="signup"
              onValuesChange={onValuesChange}
              onFinish={(values) => {
                history.push(`/SignUp/${values.msisdn}`);
              }}
              onFinishFailed={(event) =>
                console.log('onFinishFailed signup form ==> ', event)
              }
            >
              <Form.Item initialValue={data?.msisdn}
                name="msisdn"
                rules={[
                  {
                    validator: customValidators.isMsisdn,
                  },
                ]}
              >
                <Input
                  autoComplete="off"
                  maxLength={10}
                  label="GSM Numaranız"
                  style={{ width: '100%' }}
                />
              </Form.Item>
              {data?.newUser &&
                 <Col span={24} className="flex-center-center">
                <p>
                  <InfoBox
                    type="warning"
                    content={
                      <p className="info-text--big">
                        {customMessages.getMessage("913-1")}
                      </p>
                    }
                  /> 
                  </p>
               </Col>
              }
              <Form.Item>
                <Form.Item>
                  <Row justify="center" gutter={30}>
                    <Col span={12}>
                      <Button
                        type="ghost"
                        onClick={() => history.push('/Login')}
                      >
                        Geri
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        shape="round"
                        disabled={!valid}
                      >
                        Doğrula
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form.Item>
            </Form>
          </Row>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center">
            <Title center level={3}>
              Üye misiniz?
            </Title>
          </Row>
          <Row justify="center" className="margin-bottom-spacing-xxl-4">
            <Button
              type="ghost"
              style={{ width: 180 }}
              onClick={() => history.push('/Login')}
            >
              Giriş Yap
            </Button>
          </Row>
        </Col>
      </Row>
    </LayoutWithoutAuth>
  );
};
export default SignupPage;
